import { AccordionSummary } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMuiAccordionSummary = styled(AccordionSummary)`
  background-color: #0042b0;
  color: #fff;

  &.Mui-expanded {
    min-height: 32px;
  }

  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0 12px 0;
  }

  & .MuiAccordionSummary-content {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    margin: 12px 0 12px 0;
  }
`;
